import React from 'react';

import { Board } from './components/Board';
import './index.css';
function App() {
  return (
    <>
      <Board />
    </>
  );
}

export default App;
